import { HTMLInputTypeAttribute, useEffect, useState } from 'react';
import { EValueType, IField, IFieldOption } from '../../../models/form/form';
import { TextField, Checkbox } from '@mui/material';

export interface IFieldProps {
    field: IField;
    onChange?: (options: IFieldOption[]) => void;
    isReadOnly?: boolean;
}

const textFieldTypes: Map<EValueType, HTMLInputTypeAttribute> = new Map([
    [EValueType.Date, 'date'],
    [EValueType.Number, 'number'],
    [EValueType.SingleLineText, 'text'],
    [EValueType.MultiLineText, 'text'],
    [EValueType.Boolean, 'checkbox'],
]);

const InputField = ({ field, onChange }: IFieldProps) => {
    const [text, setText] = useState(field.values.length ? field.values[0] : { value: '', id: 0 });

    useEffect(() => {
        if (!text) return;
        onChange && onChange([text]);
    }, [text]);

    if (field.valueType === EValueType.Boolean) {
        return <Checkbox onChange={(e, checked) => setText((old) => ({ ...old, value: checked.toString() }))} />;
    }

    return (
        <TextField
            type={textFieldTypes.get(field.valueType)}
            required={field.required}
            value={text.value}
            onChange={(e) => setText((old) => ({ ...old, value: e.target.value }))}
            fullWidth
            multiline={field.valueType === EValueType.MultiLineText}
            rows={4}
        ></TextField>
    );
};

export default InputField;
